import React from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Calendar, Clock } from "lucide-react";

export default function LongevityMistakes() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1">
        <div className="container max-w-4xl mx-auto px-4 py-12">
          <div className="space-y-6">
            <div className="flex items-center text-[#7F8C8D] text-sm mb-4">
              <div className="flex items-center mr-4">
                <Calendar className="h-4 w-4 mr-2" />
                <span>April 8, 2025</span>
              </div>
              <div className="flex items-center">
                <Clock className="h-4 w-4 mr-2" />
                <span>8 min read</span>
              </div>
            </div>
            
            <h1 className="text-4xl font-serif font-bold text-[#2C3E50]">
              The Top 3 mistakes people make when starting longevity practices
            </h1>
            
            <p className="text-xl text-[#7F8C8D] leading-relaxed mb-8">
              Common pitfalls to avoid in your longevity journey
            </p>
            
            <div className="bg-[#F8FAFC] border border-[#E2E8F0] rounded-lg p-8 my-12 text-center">
              <h2 className="text-2xl font-medium text-[#2C3E50] mb-4">Coming Soon</h2>
              <p className="text-[#7F8C8D] mb-6">
                We're preparing a detailed analysis of the most common mistakes people make when beginning their 
                longevity practices. Drawing from clinical experience and research, this article will help you 
                avoid costly errors and create a more effective personal longevity strategy.
              </p>
              <p className="text-[#7F8C8D]">
                Please check back soon for the full article.
              </p>
            </div>
            
            <div className="border-t border-[#E2E8F0] pt-8 mt-12">
              <h3 className="text-xl font-medium text-[#2C3E50] mb-4">Topics we'll cover:</h3>
              <ul className="list-disc pl-6 space-y-2 text-[#7F8C8D]">
                <li>Overlooking foundational health practices</li>
                <li>Focusing on supplements before optimizing lifestyle</li>
                <li>Following protocols without personalization</li>
                <li>Ignoring individual biomarker data</li>
                <li>Practical solutions and alternative approaches</li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}